<div class="app-footer d-flex align-items-center justify-content-between" [class.fixed-bottom]="settings.theme.footerIsFixed">
    <span class="social-icons">
    </span>
    <span class="copyright">iDrv TMS for {{companyName}} | Copyright © 2020 Logicor Pty. Ltd. All Rights Reserved.</span>    
</div>